export default __webpack_public_path__ + "tmp_src/components/Product/ProductButtonOption~aurora.css.liquid";